import { api } from "./api";

export interface ActionProps {
    action: string;
    name: string;
    description?: string;
    created_at?: Date;
}

export const createAction = async (action: ActionProps) => {
    try {
        const result = await api.post('/user/admin/activity', action, { hideErrorToast: true })
        return { status: 'success', result };
    } catch (error) {
        const message = error instanceof Error ? error.message : String(error);
        return { status: 'error', error: message };
    }
}
